import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSearchParams } from 'react-router-dom'
import { ISetSearchParams } from 'components/core/types'
import { FormikValues } from 'formik'
import SelectTreatment from 'components/ui/selects/SelectTreatment'
import { css, StyleSheet } from 'aphrodite'
import { IApplicationState } from 'components/store/types'
import { getCurrentClinique, getCurrentPersonType, getCurrentTreatment } from 'components/core/state/selectors'
import { connect, ConnectedProps } from 'react-redux'
import Container from 'components/ui/Container'
import Form from 'components/ui/form/Form'
import CliniqueInfos from 'components/ui/CliniqueInfos'
import BackButton from 'components/ui/buttons/BackButton'
import { AppDispatch } from 'components/store/state/store'
import { saveForm } from 'components/core/state/actions'
import constants from 'utils/constants'
import ucfirst from 'utils/ucfirst'
import SelectPersonType from 'components/ui/selects/SelectPersonType'

const mapState = (state: IApplicationState) => ({
  clinique: getCurrentClinique(state),
  personType: getCurrentPersonType(state),
  treatment: getCurrentTreatment(state),
})
const mapDispatch = (dispatch: AppDispatch) => ({
  submitForm: (data, setSearchParams: ISetSearchParams) => {
    dispatch(saveForm(data, setSearchParams))
  },
})
const connector = connect(mapState, mapDispatch)

const Step3Form = ({
  clinique,
  personType,
  submitForm,
  treatment,
}: ConnectedProps<typeof connector>) => {
  const [, setSearchParams] = useSearchParams()
  const { t } = useTranslation()
  const { personTypes } = constants
  const handleSubmit = (values: FormikValues) => {
    const formData = {
      ...values,
      clinique: clinique?.title,
      cliniqueEmail: clinique?.acf.email,
      treatment: treatment.name,
      personType: t(`personTypes.${personTypes[personType]}`),
    }
    submitForm(formData, setSearchParams)
  }
  return (
    <Container>
      <div className="tw-col-span-12">
        <BackButton step={2} />
      </div>
      <div className="tw-col-span-12 xl:tw-col-start-3 xl:tw-col-span-8 tw-container tw-grid tw-grid-cols-12 tw-mx-auto tw-px-4">
        <div className="tw-col-span-12 tw-font-thin">
          {ucfirst(t('my-appointment-for'))}
          {' '}
          <SelectTreatment />
          {t('for')}
          {' '}
          <SelectPersonType />
        </div>
        <div className="tw-col-span-12 tw-font-thin">
          {t('at')}
          {' '}
          <span className={css(styles.cliniqueName)}>{clinique?.title}</span>
        </div>
        <CliniqueInfos />
        <Form onSubmit={handleSubmit} />
      </div>
    </Container>
  )
}
const styles = StyleSheet.create({
  block: {
    width: '50%',
  },
  cliniqueName: {
    fontWeight: 'bold',
  },
  container: {
    width: '800px',
    textAlign: 'left',
  },
  flex: {
    display: 'flex',
    marginTop: '48px',
    marginBottom: '48px',
  },
  sendButton: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
})

export default connector(Step3Form)
